(function($) {
    $(window).load(function(){

        var count = 15;
        var counter = null;
        function timer()
        {
            count = count - 1;
            $('[data-no-found-counter-index]').text(count);
            if (count === 1)
            {
                clearInterval(counter);
                window.location.href = '/';
            }
        }

        if($('body').hasClass('error404')){
            counter=setInterval(timer, 1000); 
        }
    });
})(jQuery);